import React from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';


const Help = () => {

  return (
    <>
      <Header />
      <main className="flex-1">
        <div className="min-h-screen bg-gray-50">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-16">
            <div className="max-w-4xl mx-auto px-4 text-center">
              <h1 className="text-4xl font-bold mb-4">How can we help you?</h1>
              <p className="text-xl mb-8">
                Find answers to common questions or get in touch with our support team
              </p>
              <div className="relative max-w-2xl mx-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-search absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5"
                >
                  <circle cx={11} cy={11} r={8} />
                  <path d="m21 21-4.3-4.3" />
                </svg>
                <input
                  className="flex h-10 w-full rounded-md border border-input px-3 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-12 py-3 text-lg bg-white text-gray-900"
                  placeholder="Search for help articles..."
                />
              </div>
            </div>
          </div>
          <div className="max-w-6xl mx-auto px-4 py-12">
            <div className="grid md:grid-cols-3 gap-6 mb-12">
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm text-center hover:shadow-lg transition-shadow">
                <div className="flex flex-col space-y-1.5 p-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-message-circle w-12 h-12 text-blue-600 mx-auto mb-4"
                  >
                    <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                  </svg>
                  <h3 className="text-2xl font-semibold leading-none tracking-tight">
                    Live Chat
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Get instant help from our support team
                  </p>
                </div>
                <div className="p-6 pt-0">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full">
                    Start Chat
                  </button>
                </div>
              </div>
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm text-center hover:shadow-lg transition-shadow">
                <div className="flex flex-col space-y-1.5 p-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-mail w-12 h-12 text-green-600 mx-auto mb-4"
                  >
                    <rect width={20} height={16} x={2} y={4} rx={2} />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                  <h3 className="text-2xl font-semibold leading-none tracking-tight">
                    Email Support
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Send us a detailed message
                  </p>
                </div>
                <div className="p-6 pt-0">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full bg-transparent">
                    Send Email
                  </button>
                </div>
              </div>
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm text-center hover:shadow-lg transition-shadow">
                <div className="flex flex-col space-y-1.5 p-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-phone w-12 h-12 text-purple-600 mx-auto mb-4"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <h3 className="text-2xl font-semibold leading-none tracking-tight">
                    Phone Support
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Call us for urgent matters
                  </p>
                </div>
                <div className="p-6 pt-0">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full bg-transparent">
                    +1 (555) 123-4567
                  </button>
                </div>
              </div>
            </div>
            <div className="space-y-8">
              <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
                Frequently Asked Questions
              </h2>
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden">
                <div className="flex flex-col space-y-1.5 p-6 bg-gray-50">
                  <div className="flex items-center gap-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-users w-8 h-8 text-blue-600"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                      <circle cx={9} cy={7} r={4} />
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <div>
                      <h3 className="font-semibold tracking-tight text-xl">
                        Getting Started
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        Learn how to create an account and join our community
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-0">
                  <div className="divide-y">
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          How do I create an account?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Click the "Sign Up" button in the top right corner and
                          follow the registration process. You'll need to provide your
                          email, create a password, and verify your email address.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          How do I join a local community?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Once you've created an account, visit the Communities page
                          and search for your city. Click "Join Community" to become a
                          member of your local travel group.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          Is the platform free to use?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Yes, joining our community and accessing basic features is
                          completely free. Some premium services from travel experts
                          may have associated costs.
                        </p>
                      </div>
                    </details>
                  </div>
                </div>
              </div>
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden">
                <div className="flex flex-col space-y-1.5 p-6 bg-gray-50">
                  <div className="flex items-center gap-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-book w-8 h-8 text-blue-600"
                    >
                      <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20" />
                    </svg>
                    <div>
                      <h3 className="font-semibold tracking-tight text-xl">
                        Travel Experts
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        Find and connect with local travel experts
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-0">
                  <div className="divide-y">
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          How do I find a travel expert?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Visit the Experts page and use our search filters to find
                          experts by location, specialty, language, or rating. You can
                          view their profiles and book consultations directly.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          What services do travel experts offer?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Our experts offer various services including personalized
                          itinerary planning, local tours, restaurant recommendations,
                          cultural experiences, and travel consultation.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          How do I become a travel expert?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Apply through our "Become an Expert" page. You'll need to
                          demonstrate local knowledge, provide references, and
                          complete our verification process.
                        </p>
                      </div>
                    </details>
                  </div>
                </div>
              </div>
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden">
                <div className="flex flex-col space-y-1.5 p-6 bg-gray-50">
                  <div className="flex items-center gap-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-credit-card w-8 h-8 text-blue-600"
                    >
                      <rect width={20} height={14} x={2} y={5} rx={2} />
                      <line x1={2} x2={22} y1={10} y2={10} />
                    </svg>
                    <div>
                      <h3 className="font-semibold tracking-tight text-xl">
                        Payments &amp; Bookings
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        Manage your bookings and payment information
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-0">
                  <div className="divide-y">
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          What payment methods do you accept?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          We accept major credit cards (Visa, MasterCard, American
                          Express), PayPal, and various local payment methods
                          depending on your region.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          How do refunds work?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Refund policies vary by service provider. Check the specific
                          cancellation policy when booking. Platform fees are
                          generally non-refundable.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          Can I modify or cancel my booking?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Modification and cancellation policies depend on the
                          specific service and expert. Contact the expert directly or
                          check your booking details for the cancellation policy.
                        </p>
                      </div>
                    </details>
                  </div>
                </div>
              </div>
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden">
                <div className="flex flex-col space-y-1.5 p-6 bg-gray-50">
                  <div className="flex items-center gap-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-shield w-8 h-8 text-blue-600"
                    >
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                    </svg>
                    <div>
                      <h3 className="font-semibold tracking-tight text-xl">
                        Safety &amp; Security
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        Stay safe while traveling and using our platform
                      </p>
                    </div>
                  </div>
                </div>
                <div className="p-0">
                  <div className="divide-y">
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          How do you verify travel experts?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          All experts go through a verification process including
                          identity verification, background checks, and review of
                          their qualifications and local knowledge.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          What should I do if I have a problem with an expert?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          Contact our support team immediately. We take all complaints
                          seriously and will investigate any issues to ensure the
                          safety and satisfaction of our community.
                        </p>
                      </div>
                    </details>
                    <details className="group">
                      <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50">
                        <h3 className="font-medium text-gray-900">
                          How do you protect my personal information?
                        </h3>
                        <div className="ml-4 flex-shrink-0">
                          <div className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform">
                            <svg
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </summary>
                      <div className="px-6 pb-6">
                        <p className="text-gray-700">
                          We use industry-standard encryption and security measures to
                          protect your data. Read our Privacy Policy for detailed
                          information about how we handle your information.
                        </p>
                      </div>
                    </details>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg border bg-card text-card-foreground shadow-sm mt-12">
              <div className="flex flex-col space-y-1.5 p-6">
                <h3 className="font-semibold tracking-tight text-2xl">
                  Still need help?
                </h3>
                <p className="text-sm text-muted-foreground">
                  Can't find what you're looking for? Send us a message and we'll get
                  back to you within 24 hours.
                </p>
              </div>
              <div className="p-6 pt-0">
                <form className="space-y-6">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label
                        htmlFor="name"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Name
                      </label>
                      <input
                        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                        id="name"
                        placeholder="Your full name"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="email"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        Email
                      </label>
                      <input
                        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                        id="email"
                        placeholder="your@email.com"
                        type="email"
                      />
                    </div>
                  </div>
                  <div>
                    <label
                      htmlFor="subject"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Subject
                    </label>
                    <input
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      id="subject"
                      placeholder="What's this about?"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="message"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Message
                    </label>
                    <textarea
                      className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      id="message"
                      rows={5}
                      placeholder="Please describe your issue or question in detail..."
                      defaultValue={""}
                    />
                  </div>
                  <button
                    className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full md:w-auto"
                    type="submit"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
            <div className="rounded-lg border text-card-foreground shadow-sm mt-8 bg-blue-50 border-blue-200">
              <div className="p-6">
                <div className="flex items-center gap-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-clock w-8 h-8 text-blue-600"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  <div>
                    <h3 className="font-semibold text-gray-900">Support Hours</h3>
                    <p className="text-gray-700">
                      Monday - Friday: 9:00 AM - 6:00 PM (EST)
                      <br />
                      Saturday - Sunday: 10:00 AM - 4:00 PM (EST)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Help;
